export var Paths;

(function (Paths) {
  Paths["Post"] = "/forms/:formName";
})(Paths || (Paths = {}));